import { render, staticRenderFns } from "./GameRoomHeader.vue?vue&type=template&id=59523026&"
import script from "./GameRoomHeader.vue?vue&type=script&lang=js&"
export * from "./GameRoomHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports